// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ta-TR","newExpiryDate":"styles_newExpiryDate__1ZtHC","footer":"styles_footer__16156"};